var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getPaddedProps(__loaderProps) {
    return __spreadArray(__spreadArray([], flattenValues(__loaderProps), true), Array(100), true).slice(0, 50).map(function (val, i, arr) { return arr[i] || 0; });
}
export var flattenValues = function (obj) {
    var result = [];
    Object.values(obj).forEach(function (value) {
        if (typeof value === 'object' && value !== null) {
            result.push.apply(result, flattenValues(value));
        }
        else if (typeof value != 'function') {
            result.push(value);
        }
    });
    return result;
};
